import { useEffect, useState } from "react";
import PageLayout from "../components/PageLayout";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

// icons
import IconComponent from "../components/Icon";
import { PiListHeartBold } from "react-icons/pi";
import { FaBookReader, FaCheck, FaPlus, FaPlusCircle, FaStar, FaTrash } from "react-icons/fa";
import { FaPencil } from "react-icons/fa6";
import { BsStars } from "react-icons/bs";
import { book, shelves } from "../assets/data/constants";
import EditBook from "../components/EditBook";

// functions
import UploadBook from "../components/UploadBook";
import axiosInstance from "../api/apiClient";

const Book = () => {
    const params = useParams();
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const edit = Boolean(searchParams.get("edit")) || false;
    const upload = Boolean(searchParams.get("upload")) || false;

    const [book, setBook] = useState<book>();
    const [bookInfo, setBookInfo] = useState<{ description: string }>();
    const [editingBook, setEditingBook] = useState<boolean>(edit);
    const [uploadingBook, setUploadingBook] = useState<boolean>(upload);
    const [hoveredStar, setHoveredStar] = useState<number>(0);

    const myBookRating = book ? book['My Rating'] : 0;

    useEffect(() => {
      axiosInstance.get(`/getBook/${params.bookId}`).then((data:any) => {
        setBook(data[0]);
      });
      
    }, []);

    useEffect(() => {
      if (editingBook) {
        // scroll naar EditBook component
        const editBookElement = document.getElementById('editBookForm');
        if (editBookElement) {
          editBookElement.scrollIntoView({ behavior: 'smooth' });
        }
      } else {
        // haal nieuwe library data op
        axiosInstance.get(`/getBook/${params.bookId}`).then((data:any) => {
        setBook(data[0]);
      });
      }
    }, [editingBook]);

    const getExclusiveShelfIcon = (shelf: string) => {
      switch (shelf) {
        case 'currently-reading':
          return <IconComponent className="size-12 opacity-45" color="#BBCFD8" icon={FaBookReader} />;
        case 'read':
          return <IconComponent className="size-12 opacity-45" color="#BBCFD8" icon={FaCheck} />;
        case 'to-read':
          return <IconComponent className="size-14 opacity-45" color="#BBCFD8" icon={BsStars} />;
        case 'favorites':
          return <IconComponent className="size-12 rotate-[-20deg] opacity-45" color="#BBCFD8" icon={PiListHeartBold} />;
        default:
          return <IconComponent className="size-12 rotate-[-20deg] opacity-45" color="#BBCFD8" icon={PiListHeartBold} />;
      }
    };

    const getGoogleBookInfo = async (isbn: string) => {
      try {
          const response = await fetch(`https://www.googleapis.com/books/v1/volumes?q=isbn:${isbn}&key=${process.env.REACT_APP_GOOGLE_API_KEY}`).then((r) => r.json());
          const bookInfo = response.items[0].volumeInfo;
          setBookInfo(bookInfo);
      } catch (error) {
        console.error('Error fetching bestsellers:', error);
      }
    };

    const updateExclusiveShelf = async (exclusive_shelf: string) => {
      if (book) {
        const editedBook = {
          "my_rating": book['My Rating'],
          "number_of_pages": book['Number of Pages'],
          "pages_read": book['Pages Read'],
          "date_read": book['Date Read'],
          "date_added": book['Date Added'],
          "exclusive_shelf": exclusive_shelf,
          "my_review": book['My Review'],
          "read_count":  book['Read Count'],
          "owned_copies": book['Owned Copies'],
          "cover_url": book['Cover URL'],
          "serie_id": book['Serie Id'],
          "serie_position": book['Serie Position'],
        }

        await axiosInstance.post(`/updateBook/${book['Book Id']}`, editedBook).then(() => {
          axiosInstance.get(`/getBook/${params.bookId}`).then((data:any) => {
            setBook(data[0]);
          });
        });

      }
     
      
    }

    const updateStars = async (stars?: number) => {
      if (book) {
        const editedBook = {
          "my_rating": stars || null,
          "number_of_pages": book['Number of Pages'],
          "pages_read": book['Pages Read'],
          "date_read": book['Date Read'],
          "date_added": book['Date Added'],
          "exclusive_shelf": book['Exclusive Shelf'],
          "my_review": book['My Review'],
          "read_count":  book['Read Count'],
          "owned_copies": book['Owned Copies'],
          "cover_url": book['Cover URL'],
          "serie_id": book['Serie Id'],
          "serie_position": book['Serie Position'],
        }

        await axiosInstance.post(`/updateBook/${book['Book Id']}`, editedBook).then(() => {
          axiosInstance.get(`/getBook/${params.bookId}`).then((data:any) => {
            setBook(data[0]);
          });
        });

      }
    }

    const addBookToLibrary = (book:any) => {
      axiosInstance.post(`/addBookToUser`, {book_id: book['Book Id']}).then(() => {
        axiosInstance.get(`/getBook/${params.bookId}`).then((data:any) => {
        setBook(data[0]);
      });
      });
    }

    const removeBookFromLibrary = (book:any) => {
      if (window.confirm('Are you sure you want to remove this book from your library? All data will be lost.')) {
          axiosInstance.post(`/removeBookFromUser`, {book_id: book['Book Id']}).then(() => {
            axiosInstance.get(`/getBook/${params.bookId}`).then((data:any) => {
            setBook(data[0]);
          });
      });
        
      }
      
    }

    useEffect(() => {
      console.log('book', book, shelves.find((shelf) => shelf.value === book?.['Exclusive Shelf']));
        const isbn = book?.['ISBN13'];
        if (isbn) {
          getGoogleBookInfo(isbn);
        }
    }, [book]);


  return (
    <PageLayout
        headerText={book ? `${book['Title']}` : 'Geen boek geselecteerd'}
        underText={book ? 
          <div className="md:flex">
            <div className="hover:underline cursor-pointer"  onClick={() => navigate(`/stats/details?type=authors-library&value=${book['Author']}`)}>
              {book['Author']}
            </div>
            {book['Serie'] &&
              <div className="ml-1 hover:underline cursor-pointer" onClick={() => navigate(`/stats/details?type=serie&value=${book['Serie Id']}`)}>
                ({book['Serie']} #{book['Serie Position']})
              </div>
            }
            
          </div> 
          : ''
        }
        type="dark"
        image={book ? book['Cover URL'] : ''}
        text={bookInfo?.description}
    >
        <div>
          { book && book['In User Library'] ?
              <>
                <div className="grid md:grid-cols-3 grid-cols-1 gap-x-[40px] mt-[40px]">
                
                    <div className="bg-white rounded-3xl shadow-lg p-4 min-h-20 hover:cursor-pointer" onClick={() => setEditingBook(!editingBook)}>
                      

                        <div className="flex justify-between items-center h-full">
                            <h1 className="text-2xl font-bold mb-0 text-[#60637A]">
                              Update
                            </h1>
                            <IconComponent className="size-12 rotate-[-20deg] opacity-45" color="#BBCFD8" icon={FaPencil} />
                        </div>
                      
                    
                    </div>
                    
                  <div className="bg-white rounded-3xl shadow-lg p-4 min-h-20 mt-[40px] md:mt-0">
                    <div className="flex justify-around items-center h-full">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <IconComponent
                        key={star}
                        className="size-10 cursor-pointer"
                        color={
                          hoveredStar >= star || myBookRating >= star
                            ? '#FFD700' // goud
                            : '#E0E9ED' // grijs
                        }
                        icon={FaStar}
                        onClick={() =>
                          myBookRating === star ? updateStars() : updateStars(star)
                        }
                        onMouseEnter={() => setHoveredStar(star)}
                        onMouseLeave={() => setHoveredStar(0)}
                      />
                    ))}
                        {/* <IconComponent className="size-10 cursor-pointer" color={myBookRating >= 1 ? '#FFD700' : '#E0E9ED'} icon={FaStar} onClick={() => myBookRating === 1 ? updateStars() : updateStars(1)}/>
                        <IconComponent className="size-10 cursor-pointer" color={myBookRating >= 2 ? '#FFD700' : '#E0E9ED'} icon={FaStar} onClick={() => myBookRating === 2 ? updateStars() : updateStars(2)}/>
                        <IconComponent className="size-10 cursor-pointer" color={myBookRating >= 3 ? '#FFD700' : '#E0E9ED'} icon={FaStar} onClick={() => myBookRating === 3 ? updateStars() : updateStars(3)}/>
                        <IconComponent className="size-10 cursor-pointer" color={myBookRating >= 4 ? '#FFD700' : '#E0E9ED'} icon={FaStar} onClick={() => myBookRating === 4 ? updateStars() : updateStars(4)}/>
                        <IconComponent className="size-10 cursor-pointer" color={myBookRating >= 5 ? '#FFD700' : '#E0E9ED'} icon={FaStar} onClick={() => myBookRating === 5 ? updateStars() : updateStars(5)}/> */}
                      </div>
                    </div>
                    <div className="bg-white rounded-3xl shadow-lg p-4 min-h-20  mt-[40px] md:mt-0">
                      {/* status */}
                       <label htmlFor="exclusive-shelf" className="block mb-2 text-sm font-medium text-gray-900">Select an option</label>
                        <select 
                          onChange={e => updateExclusiveShelf(e.target.value)} 
                          id="exclusive-shelf" 
                          className="appearance-none bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                        >
                          {Object.values(shelves).map((shelf, index) => {
                                      // if (shelf.value === book?.['Exclusive Shelf']) {
                                      //     return null;
                                      // }

                                      return(
                                          <option selected={shelf.value === book?.['Exclusive Shelf']} key={index} value={shelf.value}>{shelf.name}</option>
                                      )
                                  })}
                        </select>
                  </div>
                </div>
                {editingBook && book && <EditBook book={book} setEditBook={setEditingBook}/>}
                {uploadingBook && book && <UploadBook bookId={params.bookId}/>}
                <div className="grid md:grid-cols-2 grid-cols-1 gap-x-[40px] mt-[40px]">
                  <div className="bg-white rounded-3xl shadow-lg p-4 min-h-20">

                    <ol className="relative border-s border-gray-200 dark:border-gray-700">
                      { book?.['Exclusive Shelf'] === 'read' &&                  
                          <li className="mb-10 ms-4">
                              <div className="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -start-1.5 border border-white dark:border-gray-900 dark:bg-gray-700"></div>
                              <time className="mb-1 text-sm font-normal leading-none text-gray-400 dark:text-gray-500">{book?.['Date Read'] ? new Date(book['Date Read']).toDateString() : 'No read date available'}</time>
                              <p className="text-base font-normal text-gray-500 dark:text-gray-400">You've finished this book</p>
                          </li>
                      }
                        { book?.['Exclusive Shelf'] === 'currently-reading' &&
                          <li className="mb-10 ms-4">
                              <div className="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -start-1.5 border border-white dark:border-gray-900 dark:bg-gray-700"></div>
                              <time className="mb-1 text-sm font-normal leading-none text-gray-400 dark:text-gray-500">{new Date().toDateString()}</time>
                              <p className="text-base font-normal text-gray-500 dark:text-gray-400">You are currently on this book {Math.round((book['Pages Read'] || 0)/book['Number of Pages'] * 100)}% of this book</p>
                              {/* {book?.['Read Count'] && <p className="text-base font-normal text-gray-500 dark:text-gray-400">You are currently on {Math.round(book['Pages Read']/book['Number of Pages'] * 100)}% of this book</p>} */}
                          </li>
                        }
                        <li className="ms-4">
                            <div className="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -start-1.5 border border-white dark:border-gray-900 dark:bg-gray-700"></div>
                            <time className="mb-1 text-sm font-normal leading-none text-gray-400 dark:text-gray-500">{book?.['Date Added'] ? new Date(book['Date Added']).toDateString() : 'Date not available'}</time>
                            {/* <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Book added to your library</h3> */}
                            <p className="text-base font-normal text-gray-500 dark:text-gray-400">Book added to your library</p>
                        </li>
                    </ol>

                  </div>
                  <div className="bg-white rounded-3xl shadow-lg p-4 min-h-20 flex flex-col justify-center items-center  mt-[40px] md:mt-0">
                    <IconComponent className="size-20 opacity-45" color="#BBCFD8" icon={FaBookReader} />
                    <button className="px-5 mt-4 py-2.5 text-sm font-medium text-white bg-[#8784D8] hover:bg-[#514f82] focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg text-center" onClick={() => navigate(`/Reader/${book?.['Book Id']}`)}> Start reading </button>
                  </div>
                  
                </div>
                <div className="grid md:grid-cols-3 grid-cols-1 gap-x-[40px] mt-[40px] mb-[40px]">
                  {/* <div className="bg-white rounded-3xl shadow-lg p-4 min-h-20">
                    
                  </div> */}
                  <button onClick={() => removeBookFromLibrary(book)} className="px-5 py-2.5 mt-4  text-sm shadow-lg font-medium text-[#60637A] bg-white hover:bg-red-500 hover:text-white rounded-3xl text-center flex items-center justify-center">
                    Remove book from library
                    <IconComponent className="size-6 ml-2 opacity-45" color="#BBCFD8" icon={FaTrash} />
                  </button>
                </div>
              </>
            : ''
          }
          {book && !book['In User Library'] &&

          <div className="bg-white rounded-3xl shadow-lg px-5 py-2.5 hover:cursor-pointer hover:bg-green-500 hover:text-white group text-[#60637A]" onClick={() => addBookToLibrary(book)}>
                <div className="flex justify-between items-center h-full">
                  <h1 className="text-sm font-bold mb-0 ">
                    Add to library
                  </h1>
                  <IconComponent className="size-6 opacity-45" color="#BBCFD8" icon={FaPlusCircle} />
                </div>
            </div>
        
          }
          </div>
          
    </PageLayout>
  );
};

export default Book;